import { ParsedTelemetry, TelemetryFormat } from "../types"
import { sampleRate } from "./sample-rate"

const metresPerSecondPerKnot = 0.514444
const sensorAspectRatio = 4 / 3

const tagNumber = (point: string, tag: string) => {
    const open = `<${tag}>`
    const start = point.indexOf(open)
    if (start === -1) return NaN
    const from = start + open.length
    return Number(point.slice(from, point.indexOf("<", from)))
}

const attributeNumber = (point: string, name: string) => {
    const open = `${name}="`
    const from = point.indexOf(open) + open.length
    return Number(point.slice(from, point.indexOf('"', from)))
}

const toRadians = (degrees: number) => (degrees * Math.PI) / 180

const verticalFov = (horizontalFov: number) =>
    (2 * Math.atan(Math.tan(toRadians(horizontalFov) / 2) / sensorAspectRatio) * 180) / Math.PI

const parse = (text: string): ParsedTelemetry => {
    const points = text.split("<trkpt ").slice(1)
    const events = points.map((point) => {
        const horizontalFov = tagNumber(point, "horizontal_fov")
        return {
            timestamp: Math.round(tagNumber(point, "timecode") * 1000),
            longitude: attributeNumber(point, "lon"),
            latitude: attributeNumber(point, "lat"),
            height: tagNumber(point, "ele"),
            // despite its name and the header's PLATFORM claim, this azimuth is world-referenced; adding platform heading is wrong
            yaw: tagNumber(point, "sensor_relative_azimuth"),
            pitch: -tagNumber(point, "sensor_relative_pitch"),
            roll: tagNumber(point, "sensor_relative_roll"),
            fov: [horizontalFov, verticalFov(horizontalFov)],
            horizontalSpeed: tagNumber(point, "speed") * metresPerSecondPerKnot,
        }
    })
    return { events, samplesPerSecond: sampleRate(events.map((event) => event.timestamp)) }
}

export const geodvr = {
    name: "geodvr",
    matches: (prefix) => prefix.includes("<gpx") && prefix.includes("geoDVR"),
    parse,
} satisfies TelemetryFormat
